module.exports = __webpack_public_path__ + "static/media/Page02_org.612f01ae.jpg";